import { SEO_MULTICITY_TEMPLATE } from '../constants/templateConstants';

export const defaultPickupTime = '10:00';
export const addedMinutesForCurrentDate = 5;
export const DAY_DURATION = 24 * 60 * 60 * 1000;
const dayjs = require('dayjs');
export const convertTime12to24 = (time12h: string): string => {
  const [time, modifier] = time12h.split(' ');

  // eslint-disable-next-line prefer-const
  let [hours, minutes] = time.split(':');

  if (hours === '12') {
    hours = '00';
  }

  let hoursInNumber = parseInt(hours, 10);
  if (modifier === 'PM') {
    hoursInNumber = parseInt(hours, 10) + 12;
  }

  return `${hoursInNumber}:${minutes}`;
};

export const formatDuration = (duration: number): string => {
  if (duration < 0) return 'Invalid time';
  if (duration > 24 * 60 * 3) return 'More than 3 days';
  if (duration < 60) return `${duration} mins (appx.)`;

  const minutes = duration % 60;
  let hours = ~~(duration / 60);
  let days: null | number = null;
  if (hours > 24) {
    days = ~~(hours / 24);
    hours = hours % 24;
  }

  return `${days ? `${days} day ` : ''}${hours} hr ${minutes} mins (appx.)`;
};

export const formatDate = (date: Date) => {
  return (
    date.getFullYear() +
    '-' +
    (date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1) +
    '-' +
    (date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate())
  );
};

export const setDateAsDatePlusN = (
  url: string,
  nextNDays = 1,
  returnNextNDays = 3
): string => {
  return url
    .replace(
      /departDate=\d{1,2}-\d{1,2}-\d{4}/,
      `departDate=${dayjs(new Date())
        .add(nextNDays, 'day')
        .format('DD-MM-YYYY')}`
    )
    .replace(
      /startDate=\d{1,2}-\d{1,2}-\d{4}/,
      `startDate=${dayjs(new Date())
        .add(nextNDays, 'day')
        .format('DD-MM-YYYY')}`
    )
    .replace(
      /returnDate=\d{1,2}-\d{1,2}-\d{4}/,
      `returnDate=${dayjs(new Date())
        .add(returnNextNDays, 'day')
        .format('DD-MM-YYYY')}`
    );
};

export const setDeptAndReturnDateForMulticity = (
  url: string,
  nextNDays = 1,
  nextNDaysOnReturnTime = 4
): string => {
  const depDate = dayjs(new Date())
    .add(nextNDays, 'day')
    .format('DD-MM-YYYY');
  const returnDate = dayjs(new Date())
    .add(nextNDaysOnReturnTime + nextNDays, 'day')
    .format('DD-MM-YYYY');
  url = url
    .replace(/departDate=\d{1,2}-\d{1,2}-\d{4}/, `departDate=${depDate}`)
    .replace(/startDate=\d{1,2}-\d{1,2}-\d{4}/, `startDate=${depDate}`)
    .replace(/pickup_date=\d{1,2}-\d{1,2}-\d{4}/, `pickup_date=${depDate}`)
    .replace(/returnDate=\d{1,2}-\d{1,2}-\d{4}/, `returnDate=${returnDate}`)
    .replace(/endDate=\d{1,2}-\d{1,2}-\d{4}/, `endDate=${returnDate}`);
  if (url.includes('source=&')) {
    // Case 1: Replace empty source
    url = url.replace(/source=&/, `source=${SEO_MULTICITY_TEMPLATE}&`);
  } else if (url.match(/source=[^&]*/)) {
    // Case 2: Do nothing if source already has a value
    // No changes needed
  } else {
    // Case 3: Append source if it doesn't exist
    url += `&source=${SEO_MULTICITY_TEMPLATE}`;
  }

  return url;
};

export const setPickupTime = (url: string) => {
  return url.replace(/pickupTime=\d{1,2}:\d{1,2}/, 'pickupTime=10:00');
};

export const isTimeGreater = (timeString1: string, timeString2: string) => {
  // pass time in HH:mm format
  return getMinsInTime(timeString1) > getMinsInTime(timeString2);
};

const getMinsInTime = colonSeparatedTimeString => {
  //always pass colon separted 24 hr time string -> HH:mm
  if (!colonSeparatedTimeString) return 0;
  try {
    let [hr, mins] = colonSeparatedTimeString.split(':');
    hr = Number(hr);
    mins = Number(mins);

    return hr * 60 + mins;
  } catch (e) {
    return 0;
  }
};

export const getNearestNMinSlot = (date: Date, minuteSlot: number) => {
  const ms = 1000 * 60 * minuteSlot; // convert minutes to ms
  const roundedDate = new Date(Math.round(date.getTime() / ms) * ms);
  return roundedDate;
};

export const currentTime = () => new Date();

export const nextDay = () =>
  new Date(
    new Date(new Date().getTime() + 1 * 1000 * 60 * 60 * 24).setHours(
      10,
      0,
      0,
      0
    )
  );

export const nextDayPlusOne = () =>
  new Date(
    new Date(new Date().getTime() + 2 * 1000 * 60 * 60 * 24).setHours(
      10,
      0,
      0,
      0
    )
  );

export const datePlusOne = (date: Date) =>
  new Date(date.getTime() + 1 * 1000 * 60 * 60 * 24);

export const timePlusNHrs = (date: Date, n = 1) =>
  new Date(date.getTime() + 1000 * 60 * 60 * n);
